import { fetchClass } from "../plugins/fetchAuth.ts";
import {getUrls} from "../plugins/config.ts";
// var baseURL = getUrls().baseFida_URL;//"https://fida.forgedrift.com/";

export async function APIGetUserLocations(id:any = '') {
  const params = {
    params:{...(id && {_id:id})}
  }
  var baseURL = getUrls().baseFida_URL;
  return fetchClass(
    `${baseURL}/api/getUserLocations`,
    {
      method: "GET",
      ...params
    },
    {},
    false
  );
}